/* tslint:disable */
import { decorate, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import { Layout } from '../atoms/Layout'
import { Nav } from '../atoms/Nav'
import { ProfileDropdown } from '../organisms/ProfileDropdown'
import MenuStore from '../stores/MenuStore'
import MobileMenu from '../atoms/MobileMenu'

import { Query } from '@apollo/client/react/components'
import { GET_OWN_INTAKE_QUERY } from '../queries/GET_OWN_INTAKE_QUERY'
import { intakeMetrics } from '../organisms/Intakes/intakeMetrics/calcIntakeMetrics'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en';

export class MenuPage extends React.Component {
  menuStore

  constructor (props) {
    super(props)
    this.menuStore = MenuStore.create({})
  }

  get hasIntakeInfoBar () {
    return false
  }

  render () {
    const menuStore = this.menuStore
    menuStore.updatePath()

    let MenuItem = Nav.HomeButtonTips
    const isHCP = window.location.href.includes('HCP')
    if (menuStore.isWebInfo || window.location.href.includes('webinfo')) {
      MenuItem = Nav.HomeButtonInfo
      document.title = 'WebINFO'
    } else if (isHCP) {
      MenuItem = Nav.HomeButtonTips
    }

    return (
      <Query query={GET_OWN_INTAKE_QUERY}>{({ loading: loading2, data: data2, error: error2 }) => {
        if (loading2) { return null }
        if (error2 || !data2 || !data2.getOwnIntake) { return null }
        const intake = data2.getOwnIntake

        const {
          section1Started
        } = intakeMetrics(intake)

        let startLink = menuStore.isWebInfo || window.location.href.includes('webinfo') ? menuStore.linkSection1 : (section1Started ? menuStore.linkSection1 : '/welcome')


        return (
          <Layout hasIntakeInfoBar={this.hasIntakeInfoBar}>
            <Nav.BarTips>
              <MenuItem showHamburger={!isHCP} onClick={isHCP ? () => {
              } : () => {
                menuStore.showMenu()
              }} />
              {isHCP ? <div />
                : <MyLink store={menuStore} to={startLink}>
                  <Nav.Button
                    active={menuStore.isInfoSelected}
                  >{process.env.REACT_APP_LANGUAGE === 'es' ? 'Informacion' : 'Info'}</Nav.Button>
                </MyLink>
              }
              {
                menuStore.isWebInfo || window.location.href.includes('HCP') ? <div />
                  : [
                    <MyLink store={menuStore} to='/contents/help'>
                      <Nav.Button
                        active={menuStore.isHelpSelected}
                      >{process.env.REACT_APP_LANGUAGE === 'es' ? 'Ayuda' : 'Help'}</Nav.Button>
                    </MyLink>,
                    <MyLink store={menuStore} to='/contents/63'>
                      <Nav.Button
                        active={menuStore.isPrintSelected}
                      >{process.env.REACT_APP_LANGUAGE === 'es' ? 'Imprimir' : 'Print'}</Nav.Button>
                    </MyLink>,
                    <MyLink store={menuStore} to='/contents/who-we-are'>
                      <Nav.Button active={menuStore.isAboutSelected}>{process.env.REACT_APP_LANGUAGE === 'es' ? 'Sobre' : 'About'}</Nav.Button>
                    </MyLink>
                  ]
              }
              <ProfileDropdown color={null} />
            </Nav.BarTips>
            <MobileMenu intake={intake} store={menuStore} />
            <SecondHeader intake={intake} store={menuStore} />
            {this.renderContent(intake)}
          </Layout>
        )
      }}</Query>
    )
  }

  renderContent (intake) {
    return <div>Content</div>
  }
}

decorate(MenuPage, {
  menuStore: observable
})

const SecondHeader = observer(({ intake, store }) => {
  if (!store.isInfoSelected) {
    return null
  }

  const {
    section1Started,
    section2Started,
    section3Started,
    section4Started
  } = intakeMetrics(intake)

  return (
    <SecondHeaderStyled>
      <Fill />
      <HeaderLink
        canClick={section1Started || window.location.pathname.includes('webinfo')}
        store={store}
        link={store.linkSection1}
        active={store.isInfoSection1Selected}
        text={lang === 'es' ? 'Antes de la Cirugía' : 'Home Before Surgery'}
      />
      <HeaderLink
        canClick={section2Started || window.location.pathname.includes('webinfo')}
        store={store}
        link={store.linkSection2}
        active={store.isInfoSection2Selected}
        text={lang === 'es' ? 'Cirugía' : 'Surgery'}
      />
      <HeaderLink
        canClick={section3Started || window.location.pathname.includes('webinfo')}
        store={store}
        link={store.linkSection3}
        active={store.isInfoSection3Selected}
        text={lang === 'es' ? 'Sala de Recuperación' : 'Recovery room'}
      />
      <HeaderLink
        canClick={section4Started || window.location.pathname.includes('webinfo')}
        link={store.linkSection4}
        store={store}
        active={store.isInfoSection4Selected}
        text={lang === 'es' ? 'Después de la Cirugía' : 'Home after surgery'}
      />
      <Fill />
    </SecondHeaderStyled>
  )
})

const HeaderLink = ({ canClick, store, active, text, link }) => {
  if (active) {
    return (
      <Nav.Button active>{text}</Nav.Button>
    )
  }

  if (canClick) {
    return (
      <MyLink store={store} to={link}>
        <Nav.Button>{text}</Nav.Button>
      </MyLink>
    )
  } else {
    return (
      <Nav.Button style={{ opacity: 0.5 }}>{text}</Nav.Button>
    )
  }
}

const Fill = styled.div`
  display: flex;
  flex: 1;
`

const MyLink = withRouter((props) => {
  return (
    <MyLinkStyled
      onClick={
        () => {
          console.log('link', props.to)
          props.store.goLink(props.history, props.to)
        }
      }
      {...props} />
  )
})

const MyLinkStyled = styled.div`
  cursor: pointer;
  text-decoration: none;
  :hover {
    text-decoration: none;
  }
`

const SecondHeaderStyled = styled.div`
  height: 0px;
  display: flex;
  align-items: center;

  @media (min-width: 900px) {
    height: 70px;
    background-color: #133E66;
  }
`



// WEBPACK FOOTER //
// ./src/pages/MenuPage.js